<template>
    <ModalBase modal-type="success" @close="$emit('close')">
        <template #header>
            {{ $t('component.dialog.applydialog.title') }}
        </template>
        <template #body>
            <div class="w-full flex">
                <div v-if="error" class="w-3/3 text-red-600 font-bold text-center">
                    {{ error }}
                </div>
            </div>

            <div class="w-full flex">
                <div class="w-1/3 text-right">
                    <p class="m-1">{{ $t('component.dialog.applydialog.family') }}</p>
                </div>
                <div class="w-2/3">
                    <p class="m-1">{{ location }}</p>
                </div>
            </div>

            <div class="w-full flex">
                <div class="w-1/3 text-right">
                    <p class="m-1">{{ $t('component.dialog.applydialog.arrival_date') }}</p>
                </div>
                <div class="w-2/3">
                    <p class="m-1"><LocalizedDate :date="date"></LocalizedDate></p>
                </div>
            </div>

            <div class="w-full flex">
                <div class="w-1/3 text-right">
                    <p class="m-1">{{ $t('component.dialog.applydialog.to') }}</p>
                </div>
                <div class="w-2/3">
                    <div class="m-1">
                        <div class="relative">
                            <datepicker input-class="block appearance-none bg-white border border-blue-200 text-gray-700 py-3 px-4 rounded leading-tight w-full"
                                        :placeholder="$t('component.search.input.placeholder')"
                                        v-model="to.value"
                                        calendar-class="calendarPicker"
                                        :language="lang"
                                        :disabled-dates="{to: anreisedatum}"
                                        :highlighted="highlighted"
                                        format="dd.MM.yyyy"></datepicker>
                            <div class="cursor-pointer absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <CalendarSVG></CalendarSVG>
                            </div>
                        </div>
                        <label class="text-red-600 font-bold mt-4"
                               v-if="to.error !== ''">
                            {{ to.error }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="w-full flex">
                <div class="w-1/3 text-right">
                    <p class="m-1">{{ $t('component.dialog.applydialog.notes') }}</p>
                </div>
                <div class="w-2/3">
                    <div class="m-1">
                                <textarea v-model="note.value"
                                          class="border border-gray-500 rounded py-2 pl-2 w-full"
                                          :class="{ 'border-red-600' : note.error }"
                                          rows="10"
                                          ></textarea>
                        <label class="text-red-600"
                               v-if="note.error !== ''">
                            {{ note.error }}
                        </label>
                    </div>
                </div>
            </div>
        </template>
        <template #footer-without-padding>
            <div class="w-full flex justify-end px-4 pb-4">
                    <p class="underline inline mr-4 cursor-pointer" @click="$store.commit('app/hideApplyDialog')">{{ $t('component.dialog.applydialog.close') }}</p>
                    <button @click="apply"
                            :disabled="applyDisabled"
                            :class="[
                                  'font-bold text-white px-4 py-1',
                                  applyDisabled ? 'bg-gray-500' : 'bg-blue-500'
                            ]">
                        {{ $t('component.dialog.applydialog.apply') }}
                    </button>

            </div>
        </template>
    </ModalBase>
</template>

<script>
    import ModalBase from "@/components/shared/ModalBase";
    import { MissionService, ResourceAlreadyExistingError } from "@/services/mission.service";
    import Datepicker from 'vuejs-datepicker';
    import {de, pl} from 'vuejs-datepicker/dist/locale'
    import CalendarSVG from "@/components/shared/svgs/CalendarSVG";
    import LocalizedDate from "@/components/shared/LocalizedDate";

    import moment from 'moment';

    export default {
        name: "ApplyDialog",
        props: ['mission','location', 'date'],
        components: {
            LocalizedDate,
            ModalBase, Datepicker,CalendarSVG
        },
        data() {
            return {
                to: {
                    value: '',
                    error: ''
                },

                note: {
                    value: '',
                    error: ''
                },
                error: '',
                applyDisabled: false,
                highlighted: {
                    dates: [
                        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                    ],
                    includeDisabled: true
                }
            }
        },
        mounted() {
            this.$ga.page('/apply');
        },
        computed: {
            anreisedatum() {
                let parsedDate = moment(this.date, 'YYYY-MM-DD').add(1, 'day').toDate();
                return parsedDate;
            },

            lang() {
                if (this.$i18n.locale === 'de') {
                    return de;
                } else if (this.$i18n.locale === 'pl') {
                    return pl;
                }

                return de;
            }
        },
        methods: {
            apply() {
                if (this.to.value.length === 0) {
                    this.to.error = this.$t('component.dialog.applydialog.to.error');
                    return;
                }

                try {
                    this.applyDisabled = true;
                    MissionService.apply(this.mission.mission_id, this.note.value, this.to.value.toISOString().slice(0,10)).then(() => {
                        this.$store.commit('app/hideApplyDialog');
                        this.$store.commit('mission/lastAppliedMission', this.mission.mission_id);
                        this.$store.dispatch('mission/resetSearch');
                        this.$store.dispatch('mission/missions');
                        this.$ga.event('Applied', 'success', 'Successfully applied', 1);
                        this.$router.push({ name: 'applications' }).catch(()=>{});
                    }).catch(error => {
                        if (error instanceof ResourceAlreadyExistingError) {
                            this.error = this.$t('component.dialog.applydialog.resource_already_existing');
                        }
                    });
                } catch (e) {
                    this.error = e.message;
                }
            }
        }
    }
</script>

<style>
    .calendarPicker {
        width: 240px !important;
        left: -25px !important;
    }
</style>